import './base.scss';
import { SiteModeModal, SiteModeChangedModal, SalesTakerModal } from 'components/SiteMode';
import { isBrowser } from 'utils';
import { headerConnect as connect } from 'components/Shared/connect';
import { loadMenu } from 'components/MainMenu/actions';
import { reloadCart } from 'components/Cart/actions';
import { isReact } from 'utils/isReact';
import { Header } from './themes/BGH';
import { useHydrated } from 'components/Pagelayout/hooks';
import { useDidMount } from '@bygghemmait/hooks';
import { Stripe } from './themes/BGH/stripe';

interface MergedProps {
  reloadCart: () => void;
  loadMenu: () => void;
  shouldReloadCart: boolean;
  shouldLoadMenu: boolean;
}

export const HEADER_TOP_BAR_ID = 'header--topbar';

interface StateProps {
  hash: string;
  _loadMenu: (hash: string) => void;
}

export const HeaderView = connect<MergedProps & StateProps, Record<string, undefined>, StateProps>(
  state => ({
    hash: state.header.mainMenu.hash,
    isBot: state.appShell.isBot
  }),
  dispatch => ({
    reloadCart: () => {
      dispatch(reloadCart(false));
    },
    _loadMenu: hash => {
      dispatch(loadMenu(hash));
    }
  }),
  ({ hash, isBot, ...state }, { _loadMenu, ...dispatch }, props) => {
    return {
      ...state,
      ...dispatch,
      ...props,
      shouldReloadCart: isBrowser() && !isReact(),
      shouldLoadMenu: isBrowser(),
      loadMenu: () => _loadMenu(hash)
    };
  }
)(function _HeaderView({ loadMenu, reloadCart, shouldLoadMenu, shouldReloadCart }: MergedProps) {
  useHydrated();
  useDidMount(() => {
    if (shouldLoadMenu) {
      loadMenu();
    }
    if (shouldReloadCart) {
      reloadCart();
    }
  });

  // A wrapping div is needed here, using a fragment results in legacy pages rendering two headers for unknown reasons...
  return (
    <div>
      <Stripe />
      <Header topBarId={HEADER_TOP_BAR_ID} />
      <SiteModeModal />
      <SiteModeChangedModal />
      <SalesTakerModal />
    </div>
  );
});
